const mock = {
	value: false,
};

export default mock;
